import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-widget-card',
  imports: [TranslateModule],
  templateUrl: './dashboard-widget-card.html',
  styleUrl: './dashboard-widget-card.scss',
})
export class DashboardWidgetCard {
  @Input({ required: true }) titleKey = '';
}
